"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    style: { "position": "absolute", "width": "calc(100% + 0.25rem + 7.5px)", "height": "calc(100% + 54px)", "inset": "0", "background": "#fff8", "backdrop-filter": "blur(10px)", "z-index": "9999", "display": "flex", "align-items": "center", "justify-content": "center", "font-size": "2rem" }
};
const _hoisted_2 = { style: { "max-height": "50vh", "overflow": "auto" } };
const _hoisted_3 = { style: { "display": "flex", "align-items": "center" } };
const _hoisted_4 = { class: "the-note" };
const _hoisted_5 = { class: "the-note" };
const _hoisted_6 = { style: { "position": "absolute", "top": "calc(54px + 0.5rem)", "right": "0.25rem", "user-select": "none", "display": "flex", "flex-direction": "row-reverse", "gap": "0.5rem" } };
const _hoisted_7 = {
    class: "m-box-style",
    style: { "height": "4.5rem", "display": "flex", "gap": "2rem", "padding": "0.5rem 1rem" }
};
const _hoisted_8 = { style: { "line-height": "1", "text-align": "right" } };
const _hoisted_9 = { style: { "font-size": "2rem" } };
const _hoisted_10 = { style: { "display": "flex", "gap": "0.5rem", "pointer-events": "auto" } };
const _hoisted_11 = {
    class: "m-box-style",
    style: { "height": "4.5rem", "display": "flex", "gap": "2rem", "padding": "0.5rem 1rem" }
};
const _hoisted_12 = { class: "m-list m-box-style" };
const _hoisted_13 = { style: { "font-size": "1rem" } };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { style: { "display": "flex", "overflow": "hidden" } };
const _hoisted_16 = { style: { "flex": "none", "margin-right": "0.5rem" } };
const _hoisted_17 = { style: { "overflow": "hidden", "width": "100%" } };
const _hoisted_18 = { class: "the-note" };
const _hoisted_19 = { style: { "font-size": "8pt", "position": "absolute", "bottom": "0", "right": "0.5rem" } };
const _hoisted_20 = { style: { "font-size": "0.9em", "color": "#0076c5" } };
const _hoisted_21 = {
    key: 0,
    style: { "padding-bottom": "1rem", "margin-left": "1rem", "font-size": "0.85em", "line-height": "1", "color": "#888" }
};
const _hoisted_22 = { class: "the-note" };
const _hoisted_23 = {
    key: 1,
    style: { "margin-left": "1rem" }
};
const _hoisted_24 = {
    key: 2,
    style: { "width": "100%", "display": "flex", "align-items": "center", "justify-content": "center" }
};
const _hoisted_25 = { class: "m-list m-box-style" };
const _hoisted_26 = { style: { "font-size": "1rem" } };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { style: { "display": "flex", "overflow": "hidden" } };
const _hoisted_29 = { style: { "flex": "none", "margin-right": "0.5rem" } };
const _hoisted_30 = { style: { "overflow": "hidden", "width": "100%" } };
const _hoisted_31 = { class: "the-note" };
const _hoisted_32 = { style: { "font-size": "8pt", "position": "absolute", "bottom": "0", "right": "0.5rem" } };
const _hoisted_33 = { style: { "font-size": "0.9em", "color": "#0076c5" } };
const _hoisted_34 = {
    key: 0,
    style: { "padding-bottom": "1rem", "margin-left": "1rem", "font-size": "0.85em", "line-height": "1", "color": "#888" }
};
const _hoisted_35 = { class: "the-note" };
const _hoisted_36 = {
    key: 1,
    style: { "margin-left": "1rem" }
};
const _hoisted_37 = {
    key: 2,
    style: { "width": "100%", "display": "flex", "align-items": "center", "justify-content": "center" }
};
const vue_3 = require("vue");
const RoundIcon_vue_1 = __importDefault(require("@/components/RoundIcon.vue"));
const BssModalRequestVideo_vue_1 = __importDefault(require("@/components/BssModalRequestVideo.vue"));
const vue_map_sdk_1 = require("@xenodrive/vue-map-sdk");
const vue_basic_ui_1 = require("@xenodrive/vue-basic-ui");
const moment_1 = __importDefault(require("moment"));
const utils_1 = require("@/utils");
exports.default = (0, vue_1.defineComponent)({
    __name: 'MapMovement',
    props: {
        holding_id: {},
        company_id: {},
        section_id: {}
    },
    setup(__props) {
        const props = __props;
        const page = (0, vue_3.ref)('vehicles');
        function setPage(p) {
            if (page.value === p) {
                showPanel.value = !showPanel.value;
            }
            else {
                page.value = p;
                showPanel.value = true;
                active.value = undefined;
            }
        }
        function dateFormat(fmt, d) {
            if (!d)
                d = Date.now();
            d = new Date(d);
            const weekday = ['日', '月', '火', '水', '木', '金', '土', '日'][d.getDay()];
            return (0, moment_1.default)(d).format(fmt.replace('ddd', weekday));
        }
        const showCluster = (0, vue_3.ref)(true);
        const showLabels = (0, vue_3.ref)(true);
        const showPanel = (0, vue_3.ref)(true);
        //const showLayers = ref(false);
        const searchWords = (0, vue_3.ref)('');
        const holding_id = (0, vue_3.computed)(() => props.holding_id || undefined);
        const company_id = (0, vue_3.computed)(() => props.company_id || undefined);
        const section_id = (0, vue_3.computed)(() => props.section_id || undefined);
        function searchFilter(item) {
            const needles = searchWords.value.split(/\s+/).map((x) => x.trim());
            if (needles.length === 0)
                return true;
            const text = [item.vehicle_code, item.vehicle_name, item.user_code, item.user_name, item.section_name].join('\0');
            return needles.every((needle) => text.includes(needle));
        }
        function vehicleId(v) {
            return 'vehicle:' + v.record_id;
        }
        const vehicles = (0, vue_3.ref)([]);
        const markers = (0, vue_3.computed)(() => {
            return vehicles.value.filter(searchFilter).map((vehicle) => translateToMarker(vehicle));
        });
        const active = (0, vue_3.ref)();
        const activeVehicle = (0, vue_3.computed)(() => markers.value.find((x) => vehicleId(x.data) === active.value));
        (0, vue_3.watch)(activeVehicle, () => {
            if (activeVehicle.value) {
                mapCenter.value = activeVehicle.value.coordinate;
            }
        });
        (0, vue_3.watch)(active, () => {
            if (activeVehicle.value) {
                mapZoom.value = 15;
            }
        });
        (0, vue_3.watch)(showPanel, (v) => {
            if (!v)
                active.value = undefined;
        });
        const clusterMarkers = (0, vue_3.ref)([]);
        const clusterPopupAnchor = (0, vue_3.ref)(undefined);
        const clusterPopup = (0, vue_3.ref)(false);
        //const showHiyari = ref(false);
        //const showHazard = ref(false);
        const mapCenter = (0, vue_3.ref)([135, 35]);
        const mapZoom = (0, vue_3.ref)(7);
        const now = (0, vue_3.ref)(Date.now());
        let timer = null;
        (0, vue_3.onMounted)(() => {
            timer = setInterval(() => {
                now.value = Date.now();
            }, 1000);
        });
        (0, vue_3.onBeforeUnmount)(() => {
            if (timer)
                clearInterval(timer);
        });
        function translateToMarker(v) {
            var _a, _b, _c;
            /* eslint-disable */
            const { direction } = {
                NONE: { direction: 0 },
                N: { direction: 0 },
                NE: { direction: 45 },
                E: { direction: 90 },
                SE: { direction: 135 },
                S: { direction: 180 },
                SW: { direction: 225 },
                W: { direction: 270 },
                NW: { direction: 315 },
            }[v.direction];
            /* eslint-enable */
            const kind = page.value === 'drivers' ? 'person' : 'vehicle';
            const icon = active.value && vehicleId(v) === active.value
                ? `${kind}_selected`
                : Number(v.acc_status)
                    ? `${kind}_active`
                    : `${kind}_inactive`;
            return (0, vue_map_sdk_1.createMarker)({
                id: vehicleId(v),
                coordinate: [Number(v.longitude_w), Number(v.latitude_w)],
                overlay: icon,
                icon: 'arrow',
                direction: direction !== null && direction !== void 0 ? direction : 0,
                data: Object.assign(Object.assign({}, v), { l_vehicle_name: (_a = labelStringIfVisible(v, 'vehicle_name')) !== null && _a !== void 0 ? _a : '車両 不明', l_user_name: (_b = labelStringIfVisible(v, 'user_name')) !== null && _b !== void 0 ? _b : '乗務員 不明', l_section_name: (_c = labelStringIfVisible(v, 'section_name')) !== null && _c !== void 0 ? _c : '営業所 不明' }),
            });
        }
        function labelStringIfVisible(v, key) {
            return v[key];
        }
        /*
        function labelStringIfVisible(v: VehicleData, key: string) {
            const category_key = 'v_infolabel_settings';
            const section_id = v.section_id || '';
            return window.checkMovementSetting(section_id, category_key, key, mapData.value.movement_settings)
                ? v[key as keyof typeof v]
                : '';
        }
        */
        const vehicleAnnotations = (0, vue_3.computed)(() => [
            ...(showLabels.value
                ? [
                    { textKey: 'l_vehicle_name', offset: [24, -12], textAlign: 'left', ringColor: '#ff8' },
                    { textKey: 'l_user_name', offset: [24, 0], textAlign: 'left', ringColor: '#ff8' },
                    { textKey: 'l_section_name', offset: [24, 12], textAlign: 'left', ringColor: '#ff8' },
                ]
                : []),
        ]);
        function loadData() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const result = yield (0, utils_1.post)('/movement/map', {
                    holding_id: (_a = holding_id.value) !== null && _a !== void 0 ? _a : '-1',
                    company_id: (_b = company_id.value) !== null && _b !== void 0 ? _b : '-1',
                    section_id: (_c = section_id.value) !== null && _c !== void 0 ? _c : '-1',
                });
                vehicles.value = result.vehicles;
            });
        }
        const url_save_request_video_data = (0, vue_3.inject)('url_save_request_video_data');
        if (!url_save_request_video_data)
            throw new Error('No URL is configured');
        function requestVideo(v, time) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = yield (0, utils_1.post)(url_save_request_video_data, {
                    holding_id: v.holding_id,
                    company_id: v.company_id,
                    section_id: v.section_id,
                    vehicle_id: v.vehicle_id,
                    request_video_time: time,
                });
                // 稼働中の車載器が見つからない、要求日時を読み取れない、といった理由で
                // サーバーが要求を受け付けないことがある。その場合も通信自体は成功するため、
                // 応答の内容を見て成否を返さないと、失敗が成功として表示されてしまう。
                return (result === null || result === void 0 ? void 0 : result.status) === 'OK';
            });
        }
        function onClusterClicked(e) {
            if (e.markers && e.markers.length > 0) {
                clusterMarkers.value = e.markers;
                clusterPopupAnchor.value = [e.clientX, e.clientY];
                clusterPopup.value = true;
            }
        }
        function onMarkerClick(e) {
            if (e.markers && e.markers.length === 1) {
                active.value = e.markers[0].id;
                showPanel.value = true;
                return;
            }
            onClusterClicked(e);
        }
        function onListClick(id) {
            if (active.value !== id) {
                active.value = id;
            }
            else {
                active.value = undefined;
            }
        }
        let refreshTimer = null;
        (0, vue_3.onMounted)(() => {
            loadData();
            refreshTimer = setInterval(() => {
                loadData();
            }, 60 * 1000);
        });
        (0, vue_3.onBeforeUnmount)(() => {
            if (refreshTimer)
                clearInterval(refreshTimer);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).Map, {
                "zoom-control": "left-top",
                center: mapCenter.value,
                "onUpdate:center": _cache[7] || (_cache[7] = ($event) => ((mapCenter).value = $event)),
                zoom: mapZoom.value,
                "onUpdate:zoom": _cache[8] || (_cache[8] = ($event) => ((mapZoom).value = $event))
            }, {
                default: (0, vue_2.withCtx)(() => {
                    var _a;
                    return [
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).SidePanel, {
                            side: "overlay",
                            show: ""
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (!section_id.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [...(_cache[9] || (_cache[9] = [
                                            (0, vue_2.createElementVNode)("div", { style: { "border": "1px solid black", "padding": "0.5rem 1rem" } }, "営業所まで選択してください", -1)
                                        ]))]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]),
                            _: 1
                        }),
                        (showCluster.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).Cluster, {
                                key: 0,
                                markers: markers.value,
                                onClick: (0, vue_2.withModifiers)(onClusterClicked, ["stop"])
                            }, null, 8, ["markers"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).Markers, {
                            markers: markers.value,
                            annotations: vehicleAnnotations.value,
                            onClick: onMarkerClick
                        }, null, 8, ["markers", "annotations"]),
                        (activeVehicle.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).Pulse, {
                                key: 1,
                                center: (_a = activeVehicle.value) === null || _a === void 0 ? void 0 : _a.coordinate
                            }, null, 8, ["center"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Dropdown), {
                            active: clusterPopup.value,
                            "onUpdate:active": _cache[0] || (_cache[0] = ($event) => ((clusterPopup).value = $event)),
                            "popup-anchor": clusterPopupAnchor.value,
                            "no-trigger": ""
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.DropdownLabel), null, {
                                    default: (0, vue_2.withCtx)(() => [...(_cache[10] || (_cache[10] = [
                                            (0, vue_2.createTextVNode)("候補選択", -1)
                                        ]))]),
                                    _: 1
                                }),
                                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(clusterMarkers.value, (v) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.DropdownItem), {
                                            key: v.id,
                                            onClick: ($event) => {
                                                clusterPopup.value = false;
                                                onListClick(v.id);
                                            }
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).MarkerImage, {
                                                        icon: v === null || v === void 0 ? void 0 : v.overlay,
                                                        style: { "margin-right": "0.5rem" }
                                                    }, null, 8, ["icon"]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        (0, vue_2.createElementVNode)("div", null, [
                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(v.data.vehicle_name || '(車両 不明)') + " ", 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_4, "(" + (0, vue_2.toDisplayString)(v.data.vehicle_code) + ")", 1)
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", null, [
                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(v.data.user_name || '(乗務員 不明)') + " ", 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_5, "(" + (0, vue_2.toDisplayString)(v.data.user_code) + ")", 1)
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(v.data.section_name || '(営業所 不明)'), 1)
                                                    ])
                                                ])
                                            ]),
                                            _: 2
                                        }, 1032, ["onClick"]));
                                    }), 128))
                                ])
                            ]),
                            _: 1
                        }, 8, ["active", "popup-anchor"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).SidePanel, {
                            side: "overlay",
                            show: ""
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(dateFormat('YYYY/MM/DD (ddd)', now.value)), 1),
                                            (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)(dateFormat('HH:mm', now.value)), 1)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                            (0, vue_2.createVNode)(RoundIcon_vue_1.default, {
                                                src: "/storage/assets/img/truck.png",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (setPage('vehicles'))),
                                                active: page.value === 'vehicles'
                                            }, null, 8, ["active"]),
                                            (0, vue_2.createVNode)(RoundIcon_vue_1.default, {
                                                src: "/storage/assets/img/person.png",
                                                onClick: _cache[2] || (_cache[2] = ($event) => (setPage('drivers'))),
                                                active: page.value === 'drivers'
                                            }, null, 8, ["active"])
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Toggle), {
                                            modelValue: showLabels.value,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((showLabels).value = $event)),
                                            color: "#007bc7",
                                            position: "top"
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [...(_cache[11] || (_cache[11] = [
                                                    (0, vue_2.createTextVNode)("ラベル", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["modelValue"]),
                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Toggle), {
                                            modelValue: showCluster.value,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((showCluster).value = $event)),
                                            color: "#007bc7",
                                            position: "top"
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [...(_cache[12] || (_cache[12] = [
                                                    (0, vue_2.createTextVNode)("クラスタ", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).SidePanel, {
                            side: "right",
                            show: page.value === 'vehicles' && showPanel.value,
                            class: "m-sidepanel-right"
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Input), {
                                            modelValue: searchWords.value,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((searchWords).value = $event)),
                                            style: { "width": "100%", "border": "1px solid #ccc", "background": "#fffc", "height": "2em", "padding": "0.25em", "border-radius": "0.25rem", "font-size": "inherit" },
                                            "icon-prepend": "fa:search"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(markers.value, (x) => {
                                        var _a, _b, _c;
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: vehicleId(x.data),
                                            class: (0, vue_2.normalizeClass)(["m-card", { active: vehicleId(x.data) === active.value }]),
                                            onClick: ($event) => (onListClick(x.id))
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).MarkerImage, {
                                                        icon: (_a = x === null || x === void 0 ? void 0 : x.overlay) !== null && _a !== void 0 ? _a : 'vehicle_inactive'
                                                    }, null, 8, ["icon"])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                                    (0, vue_2.createElementVNode)("div", {
                                                        style: (0, vue_2.normalizeStyle)([{ "line-height": "1" },
                                                            active.value !== vehicleId(x.data)
                                                                ? { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }
                                                                : {}
                                                        ])
                                                    }, [
                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(x.data.vehicle_name || '(車両 不明)') + " ", 1),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_18, "(" + (0, vue_2.toDisplayString)(x.data.vehicle_code) + ")", 1)
                                                    ], 4),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_19, (0, vue_2.toDisplayString)(x.data.time), 1),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)(Number(x.data.acc_status) === 1 ? '走行中' : '停車中'), 1)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (active.value === vehicleId(x.data))
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_21, [
                                                        (0, vue_2.createElementVNode)("div", null, [
                                                            (0, vue_2.createTextVNode)(" ドライバー: " + (0, vue_2.toDisplayString)(((_b = x.data) === null || _b === void 0 ? void 0 : _b.user_name) || '(乗務員 不明)') + " ", 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_22, "(" + (0, vue_2.toDisplayString)(x.data.user_code) + ")", 1)
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", null, "所属: " + (0, vue_2.toDisplayString)(((_c = x.data) === null || _c === void 0 ? void 0 : _c.section_name) || '(営業所 不明)'), 1)
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (active.value === vehicleId(x.data))
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_23, [
                                                        (0, vue_2.createVNode)(BssModalRequestVideo_vue_1.default, {
                                                            item: x.data,
                                                            request: (time) => requestVideo(x.data, time)
                                                        }, null, 8, ["item", "request"])
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (active.value === vehicleId(x.data))
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_24, [
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Icon), {
                                                            name: "fa:angle-double-up",
                                                            size: "1rem"
                                                        })
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ])
                                        ], 10, _hoisted_14));
                                    }), 128))
                                ])
                            ]),
                            _: 1
                        }, 8, ["show"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).SidePanel, {
                            side: "right",
                            show: page.value === 'drivers' && showPanel.value,
                            class: "m-sidepanel-right"
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_25, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Input), {
                                            modelValue: searchWords.value,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((searchWords).value = $event)),
                                            style: { "width": "100%", "border": "1px solid #ccc", "background": "#fffc", "height": "2em", "padding": "0.25em", "border-radius": "0.25rem", "font-size": "inherit" },
                                            "icon-prepend": "fa:search"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(markers.value, (x) => {
                                        var _a, _b, _c;
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: vehicleId(x.data),
                                            class: (0, vue_2.normalizeClass)(["m-card", { active: vehicleId(x.data) === active.value }]),
                                            onClick: ($event) => (onListClick(x.id))
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_29, [
                                                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_map_sdk_1.MapSDK).MarkerImage, {
                                                        icon: (_a = x === null || x === void 0 ? void 0 : x.overlay) !== null && _a !== void 0 ? _a : 'person_inactive'
                                                    }, null, 8, ["icon"])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                                    (0, vue_2.createElementVNode)("div", {
                                                        style: (0, vue_2.normalizeStyle)([{ "line-height": "1" },
                                                            active.value !== vehicleId(x.data)
                                                                ? { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }
                                                                : {}
                                                        ])
                                                    }, [
                                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(x.data.user_name || '(乗務員 不明)') + " ", 1),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_31, "(" + (0, vue_2.toDisplayString)(x.data.user_code) + ")", 1)
                                                    ], 4),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_32, (0, vue_2.toDisplayString)(x.data.time), 1),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_33, (0, vue_2.toDisplayString)(Number(x.data.acc_status) === 1 ? '走行中' : '停車中'), 1)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (active.value === vehicleId(x.data))
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_34, [
                                                        (0, vue_2.createElementVNode)("div", null, [
                                                            (0, vue_2.createTextVNode)(" 車両: " + (0, vue_2.toDisplayString)(((_b = x.data) === null || _b === void 0 ? void 0 : _b.vehicle_name) || '(車両 不明)') + " ", 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_35, "(" + (0, vue_2.toDisplayString)(x.data.vehicle_code) + ")", 1)
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", null, "所属: " + (0, vue_2.toDisplayString)(((_c = x.data) === null || _c === void 0 ? void 0 : _c.section_name) || '(営業所 不明)'), 1)
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (active.value === vehicleId(x.data))
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_36, [
                                                        (0, vue_2.createVNode)(BssModalRequestVideo_vue_1.default, {
                                                            item: x.data,
                                                            request: (time) => requestVideo(x.data, time)
                                                        }, null, 8, ["item", "request"])
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (active.value === vehicleId(x.data))
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_37, [
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Icon), {
                                                            name: "fa:angle-double-up",
                                                            size: "1rem"
                                                        })
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ])
                                        ], 10, _hoisted_27));
                                    }), 128))
                                ])
                            ]),
                            _: 1
                        }, 8, ["show"])
                    ];
                }),
                _: 1
            }, 8, ["center", "zoom"]));
        };
    }
});
